<template>
  <div :class="['content', {'zh-style':language==='zh'}]">

    <empty-reminder v-if="records.length === 0 && !loading"></empty-reminder>

    <div id="pc-records" v-if="records.length > 0">
      <div class="little-title">
        <p class="description"><span>{{ $t('description') }}</span></p>
        <p class="type">{{ $t('type') }}</p>
        <p class="amount">{{ $t('amount') }}</p>
        <p class="status">{{ $t('status') }}</p>
      </div>
      <div class="records" v-for="record in records">
        <p class="description">
          {{ $t('yourFriends') }} {{ record.nickname }} {{ $t('bought') }}
          {{ record.package_device_count }} {{ $tc('devices', record.package_device_count)}}
          {{ $t(record.package_name) }}{{ $t('plan') }}
          <template v-if="record.status === 'cancelled'">{{ $t('refunded') }}</template>
        </p>
        <p class="type">{{ record.first_purchase ? $t('firstTopup') : $t('renew') }}</p>
        <p :class="['amount', {'on-hold': awardOnHold(record.status) }]">{{ $t(currentSymbol) }} {{ record[currentSymbol] }}</p>
        <p :class="['status', {'on-hold': awardOnHold(record.status) }]">{{ $t(record.status) }}</p>
      </div>
    </div>

    <div id="pager-bar">
      <div class="spinner-component-box"><spinner :show="loading"></spinner></div>
      <pager :total-page="totalPage" :init-page="currentPage" @go-page="getAwardRecords"></pager>
    </div>

  </div>
</template>

<script>
  import EmptyReminder from '../EmptyReminder.vue'
  import locales from './lang'
  import Spinner from '../../Spinner.vue'
  import Pager from '../../pager/Index.vue'
  import { mapState } from 'vuex'

  export default {
    name: 'reward-records-pc',
    components: {EmptyReminder, Spinner, Pager},
    props: ['initAwardRecords'],
    data: function () {
      return {
        records: [],
        loading: false,
        currentPage: 1,
        totalPage: 0
      }
    },
    locales,
    computed: {
      ...mapState({
        language: state => state.currentLang,
        currentSymbol: state => state.currentSymbol
      })
    },
    watch: {
      initAwardRecords() {
        this.records = this.initAwardRecords.data
        this.totalPage = Math.ceil(this.initAwardRecords.meta['total'] / this.initAwardRecords.meta['per_page'])
        this.currentPage = this.initAwardRecords.meta['current_page']
      }
    },
    methods: {
      getAwardRecords(data) {
        this.loading = true
        this.$http.get('api/commission-records?type=internal-award', {params: {'page': data.page}}).then(response => {
          this.loading = false
          this.records = response.data.data
          this.totalPage = Math.ceil(response.data.meta['total'] / response.data.meta['per_page'])
          this.currentPage = response.data.meta['current_page']
        }, response => {
          this.loading = false
        })
      },
      awardOnHold(status) {
        return status === 'pending' || status === 'cancelled'
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";

  * {
    padding: 0;
    margin: 0;
  }

  .content {
    min-height: 2.16rem;
  }

  #pc-records {
    min-height: 4.5rem;
  }

  .little-title, .records {
    line-height: .2rem;
    padding: 0.17rem 0;
    font-size: 0;
    color: #333333;
    font-weight: 600;
    letter-spacing: 0;
    border-bottom: 0.01rem solid #E0D7E3;
    display: flex;
  }

  .records {
    line-height: .2rem;
    padding: 0.17rem 0;
    font-size: 0;
    color: #666;
    letter-spacing: 0;
    border-bottom: 0.01rem solid #E0D7E3;
    font-weight: 400;
    p {
      font-size: .14rem;
      display: inline-block;
    }
  }

  p {
    font-size: .14rem;
    display: inline-block;
    text-align: center;
    &.description {
      flex-basis: 55%;
      a {
        color: #999;
        text-decoration: underline;
        &:hover {
          color: $base-blue;
        }
      }
    }
    &.type, &.amount, &.status {
      flex-basis: 15%;
    }
  }

  #pager-bar {
    padding-bottom: .4rem;
    text-align: center;
    .spinner-component-box {
      min-height: .8rem;
      padding: .1rem 0;
    }
  }
</style>



// WEBPACK FOOTER //
// RewardRecordsPc.vue?205fd542